import React from 'react'
import { useState } from 'react'
import { DocFirmadosRep } from './DocFirmadosRep'
import { DocPorFirmarRep } from './DocPorFirmarRep'

export const NavDocumentosRep = () => {

    const [ navDoc, setNavDoc] = useState(false)

    // console.log(navDoc)

  return (



    <>

    <div className='contenedorNavRepresentante'>


        <div onClick={ () => setNavDoc(false)} className={`navDocRepresentante navDocLeft ${ !navDoc && 'active' }`}>

            <p>Documentos Por Firmar</p>
       
        </div>

        <div onClick={ () => setNavDoc(true)}  className={`navDocRepresentante navDocRight ${ navDoc && 'active' }`}>

            <p>Documentos Firmados</p>

        </div>



    </div>

    {   !navDoc ?  <DocPorFirmarRep/> : <DocFirmadosRep/>}

    </>
  )
}
